import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import { useTranslation } from "react-i18next";
import i18next from "i18next";

import "../scss/NavBar.scss";
import logo from "../assets/images/widepack-logo-swirl.png";

export const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();
  const lang = (code) => {
    i18next.changeLanguage(code);
  };
  return (
    <>
      <nav>
        <Link to='/' className='title'>
          <img src={logo} alt='Widpack Logo Swirl' />
        </Link>
        <div
          className='menu'
          onClick={() => {
            setMenuOpen(!menuOpen);
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className={menuOpen ? "open" : "closed"}>
          <div className='list'>
            <ul className='list_links'>
              <li>
                <NavLink
                  to='/'
                  onClick={() => {
                    setMenuOpen(!menuOpen);
                  }}
                >
                  {t("home")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to='/why'
                  onClick={() => {
                    setMenuOpen(!menuOpen);
                  }}
                >
                  {t("why")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to='/gallery'
                  onClick={() => {
                    setMenuOpen(!menuOpen);
                  }}
                >
                  {t("gallery")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to='/contact'
                  onClick={() => {
                    setMenuOpen(!menuOpen);
                  }}
                >
                  {t("contact")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to='/location'
                  onClick={() => {
                    setMenuOpen(!menuOpen);
                  }}
                >
                  {t("location")}
                </NavLink>
              </li>
            </ul>
            <ul className='list_langs'>
              <li>
                <Link
                  onClick={() => {
                    lang("en");
                  }}
                >
                  en
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    lang("fr");
                  }}
                >
                  fr
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    lang("nl");
                  }}
                >
                  nl
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};
